import { useQuery,useMutation } from '@tanstack/react-query';
import { fetchWholesaleOrders,fetchTodaysInventory,createOrder,fetchOrderDetails,updateOrder,downloadOrders } from './wholesaleuser.api';

export const useWholesaleOrders = ({ filters, page, perPage, action }) => {
  return useQuery({
    queryKey: ['wholesale-orders', filters, page, perPage, action], // include filters + action
    queryFn: () =>
      fetchWholesaleOrders({
        filters,
        page,
        perPage,
        action,
      }),
    keepPreviousData: true,
  });
};
export const useFetchWholesaleInventory = (options = {}) => {
  return useQuery({
    queryKey: ['current-inventory'],
    queryFn: async() => {  
       const data = await fetchTodaysInventory();
      return data;},
      staleTime: 0,             // ⛔ data considered stale immediately
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: options.enabled ?? true,
    ...options
  });
};

export const useCreateOrder = (options = {}) => {
  return useMutation({
    mutationFn: createOrder,
    ...options
  });
};

export function useOrderDetails(orderid, enabled = true) {
  return useQuery({
    queryKey: ['order-details', orderid],
    queryFn: () => fetchOrderDetails(orderid),
    enabled: !!orderid && enabled,
  });
}

export const useUpdateOrder = (options = {}) => {
  return useMutation({
    mutationFn: updateOrder,
    ...options
  });
};
export const useDownloadOrders = () => {
  return useMutation({
    mutationFn: downloadOrders
  });
};